import { BaseText } from '@/src/components/BaseText'
import { ALL_LOCATIONS, useLocationsContext } from '@/src/contexts/LocationsContext'
import {
  useLoadPlanningAdjustments,
  useLoadedStrategyMetadata,
} from '@/src/features/procurement-and-markets/load-planning/hooks/LoadPlanning.hooks'
import { countAdjustments } from '@/src/features/procurement-and-markets/load-planning/load-planning-graph/LoadPlanning.utils'
import { isNullOrUndefined } from '@/src/shared/utils'
import { useTranslation } from 'react-i18next'
import { mapToEnergyTypeDto } from '../details/types/adjustment.utils'

export const LoadPlanningAdjustmentCounter = () => {
  const { data: strategyMetadata } = useLoadedStrategyMetadata()

  const { currentLocation, companyPgId: companyId } = useLocationsContext()
  const locationId = currentLocation?.locationPgId

  const { data: adjustments } = useLoadPlanningAdjustments({
    companyId,
    locationId: typeof locationId === 'number' && locationId !== ALL_LOCATIONS ? Number(locationId) : undefined,
    energyType: mapToEnergyTypeDto(strategyMetadata?.energyType),
    year: strategyMetadata?.year,
  })

  const { t } = useTranslation()
  const adjustmentCount = adjustments ? countAdjustments(adjustments) : null

  if (isNullOrUndefined(adjustmentCount)) {
    return null
  }

  return (
    <BaseText fontSize={'small'} size={'var-reg'}>
      {t('components.procurement.forecasting.adjustments_created', { count: adjustmentCount })}
    </BaseText>
  )
}
